import { getSystemSettings } from '../utils/SettingsRetriever';

const getCheckoutEntrypoint = () => {
    const config = getSystemSettings();
    let url = '/checkout/register';

    if(config.app && config.app.checkout && config.app.checkout.authentication && config.app.checkout.authentication.default === "checkoutAsGuest" && config.app.checkout.authentication.checkoutAsGuest){
        url = '/checkout/payment';
    }

    return url;
}

export {
    getCheckoutEntrypoint
};